<template>
    <v-col cols="6" sm="4" md="3" lg="2" xl="2" class="pa-2">
        <v-card :dark="order.state !== 'W'" :color="state_color"
                :style="{'border': order.collected ? '3px solid #03a9f4 !important' : 'unset'}" elevation="3">
            <v-container fluid class="py-0">
                <v-row align="center">
                    <v-col cols="9" class="pa-0">
                        <span class="font-weight-medium pl-2">
                            {{ order.state_display }}
                        </span>
                    </v-col>
                </v-row>
            </v-container>
            <v-img
                class="card-img-top"
                @click="onShowImage"
                style="cursor: pointer; "
                :src="order.image_url"></v-img>
            <v-tabs
                fixed-tabs
                center-active
                v-model="active_tab"
                class="pt-1 disable-arrow"
                v-if="replacements && replacements.length !== 1"
            >
                <v-tab
                    v-for="replacement in replacements"
                    :key="replacement.id"
                    @click.stop="changeOrder(replacement)"
                >
                    <v-img contain :src="replacement.image_url" width="50"
                           height="50"></v-img>

                </v-tab>
            </v-tabs>
            <v-card-title class="px-2 pt-0 pb-0">
                <div style="overflow: hidden">
                    <span v-if="order.purchase">№{{ client_info.number }}/{{ order.number }}</span>
                    <span v-else>Не в закупке</span>
                </div>
            </v-card-title>
            <v-container class="py-0 px-2 mt-n1" fluid>
                <v-row align="start" justify="center">
                    <v-col cols="12" v-if="order.collected" class="py-1">
                        <v-sheet elevation="3" dark class="light-blue text-center">
                            Собран
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" v-if="order.paid" class="py-1">
                        <v-sheet @click="onShowCheck" elevation="3" dark class="primary text-center pa-1"
                                 style="line-height: 17px; cursor: pointer">
                            Оплачен поставщику
                            <div class="caption mt-n1">(Показать чек)</div>
                        </v-sheet>
                    </v-col>
                    <v-col v-if="order.state_comment" cols="12" class="py-1">
                        <v-sheet elevation="3" dark class="secondary text-center">
                            {{ order.state_comment }}
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-subtitle style="line-height: 1.2" class="px-2 py-0 subtitle-1">
                {{ order.comment }}
                <v-divider></v-divider>
            </v-card-subtitle>
            <div v-if="!opened_link.additional.hide_price">
                <v-card-text v-if="show_oldprice" style="text-decoration: line-through"
                             class="pt-0 py-0 mb-n1 mt-1 pl-2 pr-0 warning">
                    {{ order.old_count }}шт. по {{ order.old_trade_price }}
                    <v-icon size="15" style="position: relative; bottom: 1px; right: 2px;">{{ icon_rub }}</v-icon>
                </v-card-text>
                <v-card-text v-if="order.paid" class="pa-0 pt-1 pl-2">
                    <div>
                        <span :class="{'count': order.count > 1}">{{ order.count }}шт.</span>
                        по {{ order.trade_price }}
                        <v-icon small style="position: relative; bottom: 1px; right: 6px;">{{ icon_rub }}</v-icon>
                    </div>
                </v-card-text>
                <v-card-text v-else class="pa-0 pt-1 pl-2">
                    {{ order.trade_price }}
                    <v-icon small style="position: relative; bottom: 1px; right: 6px">{{ icon_rub }}</v-icon>
                    <v-icon size="13" style="position: relative; bottom: 2px; right: 5px">{{ icon_mul }}</v-icon>
                    <span :class="{'count': order.count > 1}">{{ order.count }}шт.</span>
                </v-card-text>
                <v-card-title class="px-2 py-0 mt-n1">
                    = {{ total_price }}
                    <v-icon size="19.5" style="position: relative; right: 4px; bottom: 0.5px;">{{ icon_rub }}</v-icon>
                </v-card-title>
            </div>
            <div v-else>
                <v-card-title class="px-2">
                    <span :class="{'count': order.count > 1}">{{ order.count }}шт.</span>
                </v-card-title>
            </div>
            <v-divider class="mx-2"></v-divider>
            <v-container fluid class="px-4 pb-2 pt-0">
                <v-row align="center" justify="center">
                    <v-col v-if="order.collected" cols="12" class="pa-0 px-1 pt-2 text-center">
                        <v-btn @click="onToggleCollected" width="100%" :loading="toggle_collected_loading" rounded
                               class="secondary caption text-none">
                            НЕ СОБРАН
                        </v-btn>
                    </v-col>
                    <v-col v-else cols="12" class="pa-0 px-1 pt-2 text-center">
                        <v-btn @click="onToggleCollected" width="100%" :loading="toggle_collected_loading" rounded
                               class="primary caption text-none">
                            СОБРАН
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EventBus from "../../event-bus";
import { mdiCurrencyRub, mdiMultiplication, mdiPercentOutline, mdiPlus } from "@mdi/js";

export default {
    name: "SharedOrder",
    data() {
        return {
            icon_rub: mdiCurrencyRub,
            icon_percent: mdiPercentOutline,
            icon_mul: mdiMultiplication,
            icon_plus: mdiPlus,
            active_tab: 0,
            order: {},
            toggle_collected_loading: false,
        }
    },
    props: {
        index: {
            type: Number,
            required: true,
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('links', [
            'opened_link'
        ]),
        show_oldprice() {
            return this.order.count * this.order.trade_price !== this.order.old_count * this.order.old_trade_price && (
                this.order.old_count !== 0 || this.order.old_trade_price !== 0
            )
        },
        total_price() {
            return this.order.trade_price * this.order.count * !this.order.paid;
        },
        client_info() {
            return this.order.client_info
        },
        replacements: function () {
            let replacements = undefined;

            if (this.value.replacements !== undefined) {
                if (this.value.replacements.length !== 0) {
                    replacements = [...this.value.replacements];
                    if (!replacements.includes(this.value)) {
                        replacements.unshift(this.value);
                        const index = replacements.findIndex(obj => obj.collected === true)
                        if (index !== -1) {
                            replacements = replacements.filter(obj => {
                                return obj.collected === true
                            })
                        } else {
                            replacements = replacements.filter(obj => {
                                let category = this.opened_link.categories.length !== 0 ? obj.categories.some(category => this.opened_link.categories.includes(category)) : true;
                                let place = this.opened_link.places.length !== 0 ? obj.places.some(place => this.opened_link.places.includes(place)) : true;
                                return place || category
                            })
                        }
                    }
                }
            }

            if (replacements !== undefined) {
                if (replacements.length === 0) {
                    replacements = undefined;
                }
            }

            return replacements;
        },
        state_color: function () {
            switch (this.order.state) {
                case 'P': {
                    return 'green';
                }
                case 'C': {
                    return 'red';
                }
                case 'O': {
                    return 'info';
                }
                default: {
                    return undefined
                }
            }
        },
        collected_style() {
            return {
                'border': '3px solid #03a9f4 !important;'
            }
        }
    },
    methods: {
        ...mapActions('orders', [
            'toggleCollected',
        ]),
        updateOrder() {
            const vm = this;
            if (vm.replacements) {
                const index = 0;
                vm.order = vm.replacements[index];
            } else {
                vm.order = vm.value;
            }
        },
        onToggleCollected() {
            const vm = this;
            vm.toggle_collected_loading = true;
            this.toggleCollected({uuid: vm.opened_link.uuid, order_id: vm.order.id})
                .then(() => {
                    vm.updateOrder();
                    vm.toggle_collected_loading = false;
                })
                .catch(() => {
                    vm.toggle_collected_loading = false;
                    setTimeout(() => {
                        location.reload();
                    }, 3000)
                })
        },
        onShowCheck() {
            EventBus.$emit('image_dialog', this.order.payment_check_url)
        },
        onShowImage() {
            EventBus.$emit('image_dialog', this.order.image_url)
        },
        changeOrder(order) {
            this.order = order;
            if (this.edit_mode) {
                this.before_edit_order = JSON.stringify(this.order)
            }
        }
    },
    mounted() {
        if (this.replacements) {
            const index = this.replacements.findIndex(
                obj => {
                    return obj.collected === true
                }
            );
            if (index === -1) {
                this.order = this.replacements[0];
                this.active_tab = 0;
            } else {
                this.order = this.replacements[index];
                this.active_tab = index;
            }
        } else {
            this.order = this.value;
        }
    },
    watch: {
        'value': {
            handler: function () {
                this.updateOrder();
            },
            deep: true
        }
    }
}
</script>

<style scoped>

.checkbox-container {
    height: 36px;
    width: 36px;
    overflow: visible;
    float: right;
}

.checkbox {
    padding-top: 6px !important;
    padding-left: 5px !important;
}

/*.count {*/
/*    background-color: #1976d2 !important;*/
/*    color: white;*/
/*    padding: 1px 5px;*/
/*    margin-right: 2px;*/
/*    border-radius: 3px;*/
/*}*/

@media (max-width: 600px) {
    .card-img-top {
        height: 45vw;
    }
}

@media (min-width: 600px) {
    .card-img-top {
        height: 30vw;
    }
}

@media (min-width: 960px) {
    .card-img-top {
        height: 25vw;
    }
}

@media (min-width: 1264px) {
    .card-img-top {
        height: 15vw;
    }
}

@media (min-width: 1904px) {

}

</style>